export const myInfoHousingTypes = [
  'APARTMENT',
  'CONDOMINIUM',
  'DETACHED HOUSE',
  'EXECUTIVE CONDOMINIUM',
  'SEMI-DETACHED HOUSE',
  'TERRACE HOUSE',
]
